import { api } from '../config'

export const INFO_SECTION_URL = {
  get_info_sections: `${api.withAPI}/admin/sectionInfo`,
  updateInfoSection: (id: string) => `${api.withAPI}/admin/sectionInfo/${id}`,
}
